"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var networkStatusSlice_1 = require("../networkStatusSlice");
/**
 * This is just a helper function that imposes a simpler and more consistent method
 * signature for the updateRequestStatus action.
 * Before: updateRequestStatus({ id: 'foo', status: 'requesting' })
 * Now: setRequestStatus('foo', 'requesting')
 */
function setRequestStatus(id, status) {
    return networkStatusSlice_1.updateRequestStatus({
        id: id,
        status: status,
    });
}
exports.default = setRequestStatus;
//# sourceMappingURL=setRequestStatus.js.map